import React, { useEffect, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useRouteMatch } from 'react-router';
import { Switch } from 'react-router-dom';

import ListView from '../../../../base/ListView';
import { useEventMaterials } from '../../../../hooks/api/event-material/useEventMaterials';
import { useMaterials } from '../../../../hooks/api/materials/useMaterials';
import { filtersToOptions } from '../../../../hooks/api/utils/filters-to-options';
import { useFilterQuery } from '../../../../hooks/useFilterQuery';
import { dateRender } from '../../../../libs/utils';
import { EVENT_MATERIALS_ACTIONS } from '../../../../redux/eventMaterials/actions';
import {
  eventMaterialCreating,
  eventMaterialsFilters,
  eventMaterialsLoaded,
  eventMaterialsMeta,
  selectActiveEventMaterial,
  selectEventMaterials,
} from '../../../../redux/eventMaterials/selectors';
import { selectEvent } from '../../../../redux/preferences/selectors';
import CreateMaterialRequestButton from '../../../shared/materialRequests/CreateMaterialRequestButton';
import { EventMaterialDetails } from './EventMaterialDetails';

export const EventMaterialOverview = () => {
  const event = useSelector(selectEvent);
  const emMeta = useSelector(eventMaterialsMeta);
  const sloppyFilters = useSelector(eventMaterialsFilters);
  const activeEm = useSelector(selectActiveEventMaterial);
  const match = useRouteMatch<{ eventMaterialId?: string }>();

  const filt = useFilterQuery();
  let { path, url } = useRouteMatch();
  const { data, isLoading } = useMaterials();
  const em = data?.data ?? [];
  const meta = data?.meta ?? undefined;

  const listViewConf = {
    dataSet: em,
    dataMeta: meta,
    columns: [
      {
        key: 'id',
        value: 'ID',
        sort: 'id',
      },
      {
        key: 'name',
        value: 'Material',
        sort: 'id',
      },
      // {
      //   key: "amount",
      //   value: "Amount",
      //   sort: "amount"
      // },
      // {
      //   key: "updatedAt",
      //   value: "Updated",
      //   sort: "updated_at",
      //   render: (eventMaterial: any) => dateRender(eventMaterial.updatedAt)
      // }
    ],
    baseFilters: filt,
    filters: [
      {
        label: 'Material ID',
        icon: 'la-search',
        type: 'text',
        key: 'material_id',
      },
    ],
    actions: {
      deleteLink: false,
      // editLink: true,
      detailsLink: true,
    },
    url: '/admin/events/' + event.id + '/materials',
  };

  return (
    <div className="m-content">
      <div className="row">
        <div className="col-xl-12">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <h3 className="m-portlet__head-text">Event Materials</h3>
                </div>
              </div>

              <div className="m-portlet__head-tools">
                <ul className="m-portlet__nav m--margin-left-20">
                  <li className="m-portlet__nav-item">
                    {/*<CreateMaterialRequestButton*/}
                    {/*  registration={registration}*/}
                    {/*  material-requests={material-requests}*/}
                    {/*  refreshRequests={this._getRequests}*/}
                    {/*  admin={admin}*/}
                    {/*  event={event}*/}
                    {/*/>*/}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              {!isLoading && <ListView config={listViewConf} handleDelete={() => {}} handleFilterUpdate={() => {}} />}
              <Switch>
                <Route path={`${path}/:materialId`}>
                  <EventMaterialDetails />
                </Route>
              </Switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
